import type { ReactNode } from 'react';

import { GoRow } from '@/components/GoRow';
import { NOTICE_W } from '@/components/layout';
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import { cn } from '@/lib/utils';
import { useT } from '@/str';

import { CENTER } from './center';

export function Notice({
  sign,
  title,
  body,
  onRetry,
  children,
}: {
  sign: string;
  title: string;
  body?: string;
  onRetry?: () => void;
  children?: ReactNode;
}) {
  const t = useT();
  return (
    <div className={CENTER}>
      <Empty
        className={cn(
          NOTICE_W,
          'rounded-card border-border bg-card w-full flex-none gap-0 border px-6 py-[30px] md:p-[30px]',
        )}
      >
        <EmptyHeader className="gap-0">
          <EmptyMedia className="text-faint mb-0 text-2xl leading-none" aria-hidden>
            {sign}
          </EmptyMedia>
          <EmptyTitle className="m-0 mt-3.5 text-lg font-extrabold tracking-[-0.02em]">
            {title}
          </EmptyTitle>
          {body && <EmptyDescription className="mt-2">{body}</EmptyDescription>}
        </EmptyHeader>
      </Empty>
      {onRetry && (
        <GoRow className={NOTICE_W} onClick={onRetry}>
          {t.retry}
        </GoRow>
      )}
      {children}
    </div>
  );
}
